import React from "react"

import { Modal, Button, Typography } from "antd"
import styled from "styled-components";

const { Text } = Typography

interface ConfirmationModalProps {
  open: boolean;
  title: string;
  description?: string | React.ReactNode;
  cancelText?: string;
  confirmText?: string;
  confirmType?: "primary" | "default" | "dashed" | "link" | "text";
  confirmDanger?: boolean;
  closeIcon?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  open,
  title,
  description,
  cancelText = "Cancel",
  confirmText = "Confirm",
  confirmType = "primary",
  confirmDanger = false,
  closeIcon = false,
  onCancel,
  onConfirm,
}) => {
  return (
    <SModal
      title={title}
      open={open}
      onCancel={onCancel}
      closeIcon={closeIcon}
      footer={(
        <div style={{ marginTop: 40, textAlign: "right" }}>
          <Button key="cancel"
            onClick={onCancel}
            size="large"
          >
            {cancelText}
          </Button>

          <Button
            size="large"
            key="confirm"
            type={confirmType}
            danger={confirmDanger}
            onClick={onConfirm}
            style={{ marginLeft: 8 }}
          >
            {confirmText}
          </Button>
        </div>
      )}
    >
      {description && (
        <Text type="secondary">
          {description}
        </Text>
      )}
    </SModal>
  )
}

const SModal = styled(Modal)`
  .ant-modal-header {
    margin-bottom: 12px;
  }
`